import axios from "axios";

export default {
  methods: {
    /**
     * Recupera todos os analistas
     * @return {Promise<[
     *    {
     *        "cdUnimed": Number,
     *        "email": String,
     *        "idUsuarioUnimed": Number,
     *        "login": String,
     *        "nome": String
     *    }
     *    ]>}
     */
    getAnalistas() {
      return axios.get(
        this.CriarUrl({
          resource: "analista/all"
        })
      );
    }
  }
};
